// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"8eed618f","498":"f6e30b5b","513":"33efcaff","787":"d0ddaa94"}[chunkId] + ".chunk.js";
};